import React from 'react';
import i18n from '@sprinklr/display-builder/i18n';
import { NativeStylingTunableBlocks } from 'components/Sidebar/RenderTunables/NativeStylingTunableBlocks';
import { TunablesCollapse, CollapseProps } from 'components/Sidebar/RenderTunables/RenderTunables';
import ActionCheckboxGroup from 'components/_UI/Forms/Actions/ActionCheckboxGroup';
import ActionRadioGroup from 'components/_UI/Forms/Actions/ActionRadioGroup';
import LabeledFormElement from 'components/_UI/Forms/LabeledFormElement/LabeledFormElement';
import LabelGroup from 'components/_UI/Forms/LabelGroup/LabelGroup';
import { runInAction } from 'mobx';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { AnalyticsRequest } from '@sprinklr/stories/analytics/AnalyticsRequest';
import { VIRAL_CONTRIBUTORS } from './constants';
import ActionCheckboxSliderGroup from 'components/_UI/Forms/Actions/ActionCheckboxSliderGroup';

export const trendingPostTunables = ({ widget }: { widget: Widget }): TunablesCollapse => {
    const request = widget.analyticsRequests?.[0] || ({} as AnalyticsRequest);

    const { trendingPost } = widget.options;

    if (!trendingPost) {
        return null;
    }

    const isEnabled = request?.viralTrends?.some(trend => VIRAL_CONTRIBUTORS.includes(trend));

    const onChange = () => {
        if (isEnabled) {
            request.viralTrends = [];
        } else {
            runInAction(() => {
                widget.options.spikes.enabled = true;
                request.viralTrends = VIRAL_CONTRIBUTORS;
            });
        }
    };

    return {
        props: {
            label: i18n.t('Trending Post'),
            startOpen: false,
            isEnabled,
            onChange,
            ['data-testid']: 'trending-post-tunable',
        } as CollapseProps,
        children: [
            <LabelGroup
                label={i18n.t('Post Position')}
                key='position'
                data-testid='options-trending-post-position'>
                <ActionRadioGroup
                    label={i18n.t('Left')}
                    option={trendingPost?.position || {}}
                    value='selectedPosition'
                    valueCheck='left'
                    data-testid='options-trending-post-position-left'
                />
                <ActionRadioGroup
                    label={i18n.t('Right')}
                    option={trendingPost?.position || {}}
                    value='selectedPosition'
                    valueCheck='right'
                    data-testid='options-trending-post-position-right'
                />
            </LabelGroup>,
            <ActionCheckboxGroup
                key='header'
                label={i18n.t('Post Header')}
                option={trendingPost?.header || {}}
                value='enabled'
                data-testid='options-trending-post-header'
            />,
            trendingPost?.header?.enabled && (
                <ActionCheckboxSliderGroup
                    key='options-trending-post-header-marker'
                    data-testid='options-trending-post-header-marker'
                    label={i18n.t('Header Marker')}
                    showValue
                    checkbox={{
                        option: trendingPost.header.marker,
                        value: 'enabled',
                    }}
                    slider={{
                        option: trendingPost.header.marker,
                        value: 'size',
                        min: 0,
                        max: 100,
                    }}
                />
            ),
            trendingPost?.header?.enabled && trendingPost?.header?.marker?.enabled && (
                <ActionCheckboxGroup
                    key='header.marker.animation'
                    label={i18n.t('Animation')}
                    option={trendingPost.header.marker.animation}
                    value='enabled'
                    data-testid='options-trending-post-marker-animation-enabled'
                />
            ),
            <LabeledFormElement
                label={i18n.t('Native Post')}
                key='native'
                data-testid='options-trending-native-styling'>
                {NativeStylingTunableBlocks(trendingPost?.nativeStyling)}
            </LabeledFormElement>,
        ],
    };
};
